getNextEvent